import { useEffect } from 'react';

const useIframeHeight = (cripserPath: any) => {
  useEffect(() => {
    const sendHeight = () => {
      const height = document.body.scrollHeight;
      window.parent.postMessage(JSON.stringify({ type: 'adjustHeight', height: height }), cripserPath);
    };

    const messageListener = (event: { origin: string; data: any; }) => {
      if (event.origin === cripserPath) {
        const message = event.data;
        if (message === 'requestHeight') {
          sendHeight();
        }
      }
    };

    window.addEventListener('message', messageListener, false);
    const observer = new MutationObserver(sendHeight);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, characterData: true });
    sendHeight();

    return () => {
      window.removeEventListener('message', messageListener);
      observer.disconnect();
    };
  }, [cripserPath]);
};

export default useIframeHeight;